<!--
 * @Author: Huangxianlong
 * @Date: 2023-05-16 14:04:52
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2026-07-16 17:10:52
 * @FilePath: \monitor\src\components\jt-from\index.vue
 * @Description: 
-->
<template>
  <div class="jt-form-main">
    <jtSpin v-if="loading" /> 
    <Form
      ref="formValidate"
      :model="formObj"
      :rules="initRules"
      :label-width="labelWidth"
      :label-position="labelPosition"
      :class="{ 'jt-is-table': isTable }"
    >
      <Row :gutter="16">
        <Col
          :style="[
            'float: left;',
            { width: `${100 / item.colSpan || initColSpan}%` }
          ]"
          v-for="item in initColumns"
          :key="item.value"
        >
          <Divider v-if="item.isTopDivider" :dashed="item.isDashed" />
          <FormItem
            :label="item.title"
            :prop="item.value"
            :class="[
              `jt-show-item-${labelPosition}`,
              {
                'jt-bold-font': item.isBoldFont,
                'jt-show-item':
                  (['show', 'Title'].includes(item.type) && !item.notPadding) ||
                  item.isQuery
              }
            ]"
          >
            <Input
              style="width: 100%"
              v-if="item.type === 'input'"
              v-model="formObj[item.value]"
              :type="item.inputType"
              :rows="item.rows"
              :search="item.search"
              :enter-button="item.enterButton"
              :readonly="item.readonly"
              :clearable="item.clearable"
              :placeholder="item.placeholder"
              :maxlength="item.maxlength"
              :show-word-limit="item.showWordLimit"
              :disabled="item.disabled || formDisabled"
              :password="item.inputType === 'password'"
              @on-search="onSearch(item.value, formObj[item.value])"
              @on-clear="onClear(item.value, formObj[item.value])"
              @on-change="onChange($event, item, formObj[item.value])"
            ></Input>
            <InputNumber
              style="width: 100%"
              v-else-if="item.type === 'numberInput'"
              v-model="formObj[item.value]"
              :max="item.max"
              :min="item.min"
              :step="item.step"
              :precision="item.precision"
              :formatter="item.formatter"
              :parser="item.parser"
              :placeholder="item.placeholder"
              :controls-outside="item.controlsOutside"
              :disabled="item.disabled || formDisabled"
              @on-change="onChange($event, item, formObj[item.value])"
            ></InputNumber>
            <DatePicker
              style="width: 100%"
              v-else-if="item.type === 'time'"
              v-model="formObj[item.value]"
              :type="item.inputType"
              :format="item.format"
              :start-date="new Date(startDate)"
              :placement="item.placement"
              :placeholder="item.placeholder"
              :disabled="item.disabled || formDisabled"
              :options="item.options"
              :clearable="item.clearable"
              @on-change="onChange($event, item, formObj[item.value])"
            ></DatePicker>
            <CheckboxGroup
              style="width: 100%"
              v-else-if="item.type === 'CheckboxGroup'"
              v-model="formObj[item.value]"
              :disabled="item.disabled || formDisabled"
              @on-change="onChange($event, item, formObj[item.value])"
            >
              <Checkbox
                v-for="i in item.openList"
                :label="i.value"
                :key="i.value"
              >
                {{ i.label }}
              </Checkbox>
            </CheckboxGroup>
            <RadioGroup
              style="width: 100%"
              v-else-if="item.type === 'RadioGroup'"
              v-model="formObj[item.value]"
              :disabled="item.disabled || formDisabled"
              @on-change="onChange($event, item, formObj[item.value])"
            >
              <Radio v-for="i in item.openList" :label="i.value" :key="i.value">
                {{ i.label }}
              </Radio>
            </RadioGroup>
            <Select
              style="width: 100%"
              :ref="item.value"
              v-else-if="item.type === 'select'"
              v-model="formObj[item.value]"
              :disabled="item.disabled || formDisabled"
              :placeholder="item.placeholder"
              :multiple="item.multiple"
              :clearable="item.clearable"
              :filterable="item.filterable"
              :filter-by-label="item.filterByLabel"
              :not-found-text="item.notFoundText"
              :transfer="item.transfer"
              :transfer-class-name="item.transferClassName"
              @on-clear="onClear(item.value, formObj[item.value])"
              @on-change="onChange($event, item, formObj[item.value])"
            >
              <Option
                v-for="i in item.openList"
                :value="i[item.openKey]"
                :key="i.value"
                :disabled="i.disabled"
              >
                {{ i[item.showKey] || i.label }}
                <!-- <span v-if="i.userNumber&&i.userLimit">{{'('+i.userNumber+'/'+i.userLimit+')'}}</span> -->
              </Option>
            </Select>
            <i-switch
              v-else-if="item.type === 'switch'"
              v-model="formObj[item.value]"
              :true-value="item.trueValue"
              :false-value="item.falseValue"
              :disabled="item.disabled || formDisabled"
              @on-change="onChange($event, item, formObj[item.value])"
            />
            <slot
              v-else-if="item.type === 'slot'"
              :row="item"
              :value="formObj[item.value]"
              :name="item.slot"
            ></slot>
            <div
              v-else-if="item.type === 'Title'"
              :class="{ 'jt-title-icon': item.isIcon }"
            >
              {{ item.text }}
            </div>
            <div
              v-else-if="item.type === 'show'"
              :class="[
                'jt-show-item-div',
                { 'jt-show-data-div': item.isDivBg }
              ]"
            >
              <Tooltip
                transfer
                placement="bottom-end"
                :disabled="!item.isTooltip"
                :max-width="item.tooltipMaxWidth || 300"
              >
                <div slot="content">
                  {{ isSetShowData(item, formObj[item.value]) }}
                </div>
                {{ isSetShowData(item, formObj[item.value]) }}
              </Tooltip>
            </div>
            <slot :name="item.slotName"></slot>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <slot name="footerButton"></slot>
  </div>
</template>

<script>
import dayjs from "dayjs";
import uniqBy from "lodash/unionBy";
import { isInstallRules, judgeTimeSize } from "@/libs/util";

export default {
  name: "JTForm",
  components: {},
  props: {
    columns: {
      type: Array,
      default: () => {
        return [];
      }
    },
    form: {
      type: Object,
      default: {}
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      }
    },
    labelWidth: {
      type: Number,
      default: 80
    },
    labelPosition: {
      type: String,
      default: "left"
    },
    // 每行渲染多少列
    colSpan: {
      type: [Number, String],
      default: 1
    },
    noDataDisplay: {
      type: String,
      default: "无"
    },
    startDate: {
      type: [String, Date],
      default: () => {
        return new Date();
      }
    },
    formDisabled: {
      type: Boolean,
      default: false
    },
    isTable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formObj: {}
    };
  },
  computed: {
    initColumns() {
      return [...this.columns];
    },
    initRules() {
      if (this.rules && Object.keys(this.rules).length) {
        return { ...this.rules };
      }
      return isInstallRules(this.initColumns);
    },
    // 计算row组件col的span属性
    initColSpan() {
      return 100 / (this.colSpan - 0);
    }
  },
  methods: {
    onValuesChange(data, item) {
      this.$refs.formValidate.validateField(item.value);
      if (data.length && data[0].name) {
        if (item.isSpecial) {
          this.formObj[item.switchValue] =
            data && data.map(({ name }) => ({ name }));
        } else {
          this.formObj[item.switchValue] = data[0].name;
        }
      }
    },
    onSearch(itemKey, value) {
      this.$emit("onSearch", itemKey, value);
    },
    onClear(itemKey, value) {
      this.$emit("onClear", itemKey, value);
    },
    onSiteSelectionChange(isCheckedData, item) {
      this.$set(this.formObj, item.value, isCheckedData.id);
      this.$set(this.formObj, item.switchValue, isCheckedData.name);
      this.isCheck(item.value);
      this.$emit("onChange", isCheckedData);
    },
    onChange(event, item, value) {
      this.$refs.formValidate.validateField(item.value);
      let newEvent = event;
      const changeData = {
        key: item.value
      };
      if (item.isSwitch) {
        changeData[item.value] = event;
        changeData.isSwitch = true;
      } else if (item.isTimeSwitch) {
        let newValues = newEvent;
        if (!newValues) {
          newValues = ["", ""];
        }
        if (item.isDateTimeSwitch) {
          newValues = [newEvent, newEvent];
        }
        const judgeResult = judgeTimeSize(newValues);
        switch (judgeResult.result) {
          case "equal":
            newValues = [
              newValues[0],
              newValues[1].replace("00:", "23:").replace(":00", ":59")
            ];
            break;
          case "small":
            newValues = judgeResult.newTimes;
            break;
        }
        changeData[item.value] = item.isDateTimeSwitch
          ? newValues[1]
          : newValues;
        changeData.startKey = item.startValue;
        changeData[item.startValue] = newValues[0];
        changeData.endKey = item.endValue;
        changeData[item.endValue] = newValues[1];
        changeData.isTimeSwitch = true;
      } else if (item.isYearTime) {
        changeData[item.value] = dayjs(value).format(item.switchFormat);
      } else {
        changeData[item.value] = value;
      }
      this.$emit("update:form", this.formObj);
      this.$emit("onChange", newEvent, changeData);
    },
    isSetShowData(item, value) {
      if (item.isNotShowValue) {
        return "";
      }
      if (item.isTransform) {
        const newShowData = item.openList.find(
          el => el[item.transformKey] === value
        );
        if (newShowData) {
          return newShowData[item.transformShowKey];
        }
        if (item.isShowDefault) {
          return value;
        }
        return this.noDataDisplay;
      }
      return value || value === 0 ? value : this.noDataDisplay;
    },
    async isCheck(key) {
      if (!key) {
        // this.initColumns.forEach(item => {
        //   if (!this.formObj[item.value] && item.type != "numberInput") {
        //     this.formObj[item.value] = "";
        //   }
        // });
      }
      return await this.$refs.formValidate.validate(key);
    },
    isResetFields() {
      this.$refs.formValidate.resetFields();
      this.formObj = {};
    },
    // 清空select选择器已选中的选项
    clearSingleSelect(value) {
      this.$nextTick(() => {
        this.$refs[value][0].clearSingleSelect();
      });
    }
  },
  watch: {
    form: {
      handler(val) {
        this.formObj = {
          ...val
        };
      },
      deep:true,
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.centered-layout {
  display: flex;
  align-items: center;
  justify-content: center;
}

.default-font {
  font-size: 15px;
  font-weight: 400;
  font-family: Microsoft YaHei;
}

// 超出...
.beyond-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

// 超出2行...
.beyond-ellipsis-two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
}

.jt-form-main {
  width: 100%;
  height: 100%;
  position: relative;
  .centered-layout();
  flex-wrap: wrap;

  .jt-show-data-div {
    /deep/ .ivu-tooltip-rel {
      border-radius: 5px;
      padding: 0 10px;
      background-color: #f3f3f3;
      opacity: 1;
      cursor: not-allowed;
      color: #ccc;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.jt-show-item {
  margin-bottom: 0;

  /deep/ .ivu-form-item-label {
    padding: 0;
    padding-right: 5px;
    display: flex;
    align-items: center;
    height: 40px;
  }

  /deep/.ivu-form-item-content {
    .centered-layout();
    justify-content: flex-start;
    height: 40px;
  }

  .jt-show-item-div {
    .centered-layout();
    width: 100%;
    height: 100%;
  }
}

/deep/.ivu-form-label-top {
  .ivu-form-item-label {
    text-align: left;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
  }
}

.jt-bold-font {
  color: #333333;
  font-weight: bold !important;
  .default-font();
}

.ivu-divider {
  margin: 16px 0;
}

.jt-title-icon {
  .centered-layout();
  justify-content: flex-start;
  padding-left: 10px;
  margin-left: -10px;
  .default-font();
  font-weight: bold;
  color: #333333;

  &::before {
    content: "";
    width: 5px;
    height: 20px;
    display: block;
    position: absolute;
    left: -12px;
    margin-top: -1px;
    background: #087eff;
  }
}

.jt-is-table {
  .ivu-row,
  .ivu-form-item {
    margin: 0 !important;
  }

  .ivu-col {
    padding: 0 !important;
  }

  .publice-style {
    .centered-layout();
    justify-content: flex-start;
    height: 40px;
  }

  border: 1px solid #dce4eb;
  border-left: 0;
  border-bottom: 0;

  /deep/.ivu-form-item-label {
    background: #f0f3fa;
    padding: 0 25px;
    .publice-style();
    .default-font();
    font-weight: bold;
    color: #333333;
    border: 1px solid #dce4eb;
    border-top: 0;
  }

  /deep/.ivu-form-item-content {
    padding: 0 10px;
    border-bottom: 1px solid #dce4eb;
    .publice-style();
  }
}

.ivu-tooltip {
  .centered-layout();
  justify-content: flex-start;
}

.ivu-tooltip,
.ivu-tooltip-rel {
  width: 99%;
  height: 100%;
  .beyond-ellipsis();
}

.ivu-form {
  width: 100%;
}

.disabled-select {
  .ivu-select-item-disabled,
  .ivu-select-item-disabled:hover {
    color: #c5c8ce !important;
  }
}

.jt-show-item-right {
  /deep/ .ivu-form-item-label {
    justify-content: flex-end;
  }
}

.hidden-selector-btn {
  /deep/.user-selector-input .ivu-input-search {
    display: none;
  }

  /deep/.ivu-input {
    border-radius: 4px;
  }
}
/deep/.ivu-form .ivu-form-item-label {
  padding: 10px 12px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/jt-from/index.vue